import React, {useEffect} from 'react'
import {Grid, CircularProgress, Alert} from '@mui/material'
import useCustomerData from '../../../hooks/useCustomerData'
import {CUSTOMER_TYPE} from '../../../utils/constants'
import themesApi from '../../../services/api/themes/themeApi'
import WbButton from '../../../components/common/WbButton'
import {getApiHookParams} from '../../../auth'

function ThemePreview({
  theme,
  surveyThemes,
  setTheme,
  survey,
  canApply = true,
}) {
  const [hovered, setHovered] = React.useState(false)
  const isDefault = (theme.MatId > 0 || theme.SchoolId > 0) && theme.IsDefault

  return (
    <div>
      <div
        className="generated-theme-card"
        style={{
          background: theme.backgroundColor,
        }}
        onMouseEnter={() => canApply && setHovered(true)}
        onMouseLeave={() => canApply && setHovered(false)}
      >
        <Grid container columnSpacing={1}>
          <Grid item xs={12}>
            {/* <div style={{ color: theme.textColor, marginTop: 0, fontSize: '15px', fontWeight: 600}}>Question</div> */}
            <hr
              style={{
                height: '7px',
                backgroundColor: theme.textColor,
                border: 'none',
                marginTop: 0,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            {/* <div style={{ color: theme.textColor, marginTop: 5, fontSize: '13px'}}>Description Content</div> */}
            <hr
              style={{
                height: '7px',
                backgroundColor: theme.textColor,
                border: 'none',
                width: '50%',
                marginTop: 0,
              }}
            />
          </Grid>
          {/* <Grid item xs={5} mt={1}>
            <div style={{ borderRadius: '5px', backgroundColor: theme.textColor, padding: '7px' }}>
              &nbsp;
            </div>
          </Grid> */}
          <Grid item xs={12} mt={1}>
            <div
              style={{
                borderRadius: '5px',
                backgroundColor: theme.answerColor,
                color: theme.textColor,
                padding: '7px',
              }}
            >
              Answer Options
            </div>
          </Grid>
          <Grid item xs={5} mt={1}>
            <div
              style={{
                backgroundColor: theme.buttonColor,
                color: theme.buttonTextColor,
                padding: '7px',
                borderRadius: '5px',
                textAlign: 'center',
              }}
            >
              Button
            </div>
          </Grid>
        </Grid>
        {hovered && (
          <div className="theme-card-hover">
            <WbButton
              onClick={async () => {
                const t = {
                  themeId: theme.id,
                  surveyId: survey.id,
                  font: theme.font,
                  backgroundColor: theme.backgroundColor,
                  accentColor: theme.accentColor,
                  textColor: theme.textColor,
                  buttonColor: theme.buttonColor,
                  buttonTextColor: theme.buttonTextColor,
                  answerColor: theme.answerColor,
                  headerImageUrl: theme.headerImageUrl ?? '',
                  footerImageUrl: theme.footerImageUrl ?? '',
                  audience: 1,
                  matGroupId: theme.matId,
                  schoolId: survey.schoolId,
                }
                setTheme(t)
                var done = await themesApi.updateSurveyThemes(t)
              }}
              CustomButtonText="Use Theme"
            />
          </div>
        )}
      </div>
      <div className="theme-name">{theme.name}</div>
    </div>
  )
}

export default function Themes({survey, surveyTheme, setTheme}) {
  const [themes, setThemes] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const apiParams = getApiHookParams()

  useEffect(() => {
    async function fetchThemes() {
      try {
        const matId =
          apiParams.groupId > 0 && apiParams.schoolId === null
            ? apiParams.groupId
            : apiParams.schoolId !== null && apiParams.group
              ? apiParams.group.group_id
              : 0
        const schoolId = apiParams.schoolId > 0 ? apiParams.schoolId : 0
        setLoading(true)
        const response = await themesApi.getCustomerThemes(schoolId, matId)
        setLoading(false)
        
        setThemes(response?.filter(x => x.id != surveyTheme?.themeId) || [])
      } catch (error) {
        setLoading(false)
        console.error('Failed to fetch themes:', error)
      }
    }

    fetchThemes()
  }, [])
  return (
    <div>
      <Grid container p={3} spacing={2}>
        {surveyTheme && (
          <Grid item xs={12}>
            <Grid item xs={12} mb={2}>
              <h3>
                <strong>Current Theme</strong>
              </h3>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <ThemePreview
                canApply={false}
                key={surveyTheme.name}
                theme={surveyTheme}
                surveyThemes={surveyTheme}
                setTheme={setTheme}
                survey={survey}
              />
            </Grid>
          </Grid>
        )}
        {loading ? (
          <div className="loading-overlay">
            <CircularProgress />
          </div>
        ) : (
          <>
            <Grid item xs={12}>
              <h3>
                <strong>Change Theme</strong>
              </h3>
              <Alert severity="info" sx={{mt: 2, mb: 2}}>
                You can select a different theme from your organisation's saved
                themes to apply to this survey.
              </Alert>
            </Grid>
            {themes?.map(theme => (
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <ThemePreview
                  key={theme.name}
                  theme={theme}
                  surveyThemes={surveyTheme}
                  setTheme={setTheme}
                  survey={survey}
                />
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </div>
  )
}
